module.exports = __webpack_public_path__ + "static/iflix-9cdcb48e100cae06c1838f11f16e1368.png";